module.exports = __webpack_public_path__ + "img/icon-edge.386d74b1.svg";